import Vue from 'vue';
import axios from 'axios';

// initial state
const state = {
  category: {},

  // record info
  currentRecord: {},
  showRecordInfo: false,

  // paginate records
  filters: { page: 1 },
  totalPages: 0,
  records: [],
}

// mutations
const mutations = {

  // record info
  SET_CURRNET_RECORD(state, record) {
    state.currentRecord = record;
  },

  SHOW_RECORD_INFO(state) {
    state.showRecordInfo = true;
  },

  HIDE_RECORD_INFO(state) {
    state.showRecordInfo = false;
  },

  // paginate records
  SET_TOTAL_PAGES(state, totalPages) {
    state.totalPages = totalPages;
  },

  SET_CATEGORY(state, category) {
    state.category = category;
  },

  SET_FILTERS(state, filters) {
    for (const key in filters) {
      if (filters[key] == '') {
        filters[key] = undefined;
      }
    }
    state.filters = filters;
  },

  SET_RECORDS(state, records) {
    state.records = records;
  },

  // manage
  UPDATE_RECORD(state, record) {
    let recordIndex = state.records.findIndex((item) => {
      return item.id == record.id;
    });
    Vue.set(state.records, recordIndex, JSON.parse(JSON.stringify(record)));
  },

  DELETE_RECORD(state, recordId) {
    state.records.forEach((item, index) => {
      if (item.id == recordId) state.records.splice(index, 1);
    });
  },
}

// actions
const actions = {

  fetchCategory({ commit }, { id }) {
    return axios.get(`/admin/categories/${id}`)
      .then((response) => {
        commit('SET_CATEGORY', response.data);
      });
  },

  // =========================================================================

  fetchRecords({ state, commit }) {
    return axios.get('/admin/articles', { params: state.filters })
      .then((response) => {
        commit('SET_RECORDS', response.data.data);
        commit('SET_TOTAL_PAGES', response.data.last_page);
      });
  },

  // =========================================================================

  fetchRecord({ commit }, { id }) {
    return axios.get(`/admin/articles/${id}`)
      .then((response) => {
        commit('SET_CURRNET_RECORD', response.data.record);
      });
  },

  // =========================================================================

  create({ }, { form }) {
    let payload = new FormData;
    for (const property in form) {
      if (!form.hasOwnProperty(property) || window.isEmpty(form[property])) {
        continue;
      }

      if (Array.isArray(form[property])) {
        for (const iterator of form[property]) {
          payload.append(property + '[]', iterator);
        }
      }
      else {
        payload.append(property, form[property]);
      }
    }

    return axios.post('/admin/articles', payload);
  },

  // =========================================================================

  update({ }, { form }) {
    let payload = new FormData;
    for (const property in form) {
      if (!form.hasOwnProperty(property) || window.isEmpty(form[property])) {
        continue;
      }

      if (Array.isArray(form[property])) {
        for (const iterator of form[property]) {
          payload.append(property + '[]', iterator);
        }
      }
      else {
        payload.append(property, form[property]);
      }
    }

    return axios.post(`/admin/articles/${form.id}`, payload);
  },

  // =========================================================================

  delete({ commit }, { recordId }) {
    return axios.delete(`/admin/articles/${recordId}`)
      .then((response) => {
        commit('DELETE_RECORD', recordId);
        return response;
      });
  },

  // =========================================================================

  publish({ }, { recordId }) {
    return axios.post(`/admin/articles/${recordId}/publish`);
  },

  // =========================================================================

  unpublish({ }, { recordId }) {
    return axios.delete(`/admin/articles/${recordId}/publish`);
  }
}

export default {
  namespaced: true,
  name: 'articles',
  state,
  actions,
  mutations
}
